const app_leave = {
  state: {
    last_leave_time: 0,
  },
  mutations: {
    SET_LAST_LEAVE_TIME(state, time) {
      state.last_leave_time = time;
    }
  },
  actions: {
    setLastLeaveTime({ commit, state }, time) {
      commit("SET_LAST_LEAVE_TIME", time);
    }
  }
};

export default app_leave;
